import React, { useState, useEffect } from "react";
import { Button } from "../../shared/inputs";
import UserThumbnail from "../userThumbnail/userThumbnail";

import { NetworkAxios, UserActivityAxios } from "../../API";
import { useSelector } from 'react-redux';
import { CONNECTION_STATUS } from "../../shared/Enum";

const ConclaveMember = (props) => {
    const [btnLabel, setBtnLabel] = useState("Connect");
    const [btnColor, setBtnColor] = useState("");

    const loggedInUser = useSelector((state) => state.auth.loggedInUser);
    let messagePoint = { ...useSelector((state) => state.auth.messagePoint) };
    const sendConnection = () => {
        if (props.item.connectionStatus == CONNECTION_STATUS.requestRecieved) {
            var requestData = {
                message: messagePoint,
                isBackgroundJob: false
            };
            NetworkAxios.post('Connection/acceptconnection?connectionId=' + props.item.connectionId, requestData)
                .then(function (response) {
                    console.log(response.data);
                    props.refreshMembers();
                    var notificationData = [
                        {
                            offeringId: loggedInUser.offeringId,
                            missionId: loggedInUser.missionId,
                            activityBy: loggedInUser.offeringUserId,
                            offeringUserId: props.item.offeringUserId,
                            teamId: loggedInUser.teamId,
                            notificationText: `accepted your connection request.`,
                            actionRoute: JSON.stringify({ action: null, actionText: "NA" })
                        }
                    ];

                    var requestObject = {
                        requestModel: notificationData,
                        message: messagePoint,
                        isBackgroundJob: false
                    };

                    UserActivityAxios.post('Notification/sendnotifications', requestObject)
                        .then(function (res) {
                        })
                        .catch(function (er) {
                            console.log(er);
                        });
                })
                .catch(function (error) {
                });
        }
        if (props.item.connectionStatus == CONNECTION_STATUS.sendRequest) {
            var requestData = {
                requestModel: {
                    "offeringUserId": props.item.offeringUserId,
                    "sender": loggedInUser.offeringUserId,
                    "connectionStatus": 0
                },
                message: messagePoint,
                isBackgroundJob: false
            };
            NetworkAxios.post('/Connection/sendconnection', requestData)
                .then(function (response) {

                    var notificationData = [
                        {
                            offeringId: loggedInUser.offeringId,
                            missionId: loggedInUser.missionId,
                            activityBy: loggedInUser.offeringUserId,
                            offeringUserId: props.item.offeringUserId,
                            teamId: loggedInUser.teamId,
                            notificationText: `sent you a connection request.`,
                            actionRoute: JSON.stringify({ action: "send-connection", sender: props.item.userId, connectionId: response.data, actionText: "View" })

                        }
                    ];
                    var requestObject = {
                        requestModel: notificationData,
                        message: messagePoint,
                        isBackgroundJob: false
                    };
                    UserActivityAxios.post('Notification/sendnotifications', requestObject)
                        .then(function (res) {
                        })
                        .catch(function (er) {
                            console.log(er);
                        });

                    props.refreshMembers();


                })
                .catch(function (error) {
                });
        }

    };

    useEffect(() => {

        if (props.item.connectionStatus == CONNECTION_STATUS.requestSent) {
            setBtnLabel("Request sent");
            setBtnColor("C00FFCA");
        }
        if (props.item.connectionStatus == CONNECTION_STATUS.requestRecieved) {
            setBtnLabel("Approve request");
        }
        if (props.item.connectionStatus == CONNECTION_STATUS.connected) {
            setBtnLabel("Connected");
            setBtnColor("C00FFCA");
        }

    }, []);


    return (
        <div className="conclave-member">
            <UserThumbnail data={props.item} className="mb-2" />
            <div className="member-name">{props.item.firstName + ' ' + props.item.lastName}</div>
            <div className="member-mission">{props.item.missionName}</div>
            <Button className={btnColor} style={{ minWidth: "120px", maxWidth: "120px" }} onClick={sendConnection}>{btnLabel}</Button>
        </div>
    );
};

export default ConclaveMember;